module.exports = require('./HorizontalStepper.vue');